export default "__VITE_ASSET__e5vf5Kt$__"